import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { RESOURCE_TYPES } from '../helpers/resourceTypes';

export const MobileGenerateResourceMenu = ({ id }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const goTo = (route) => {
    setIsOpen(false);
    navigate(route);
  };

  return (
    <>
      {isOpen && <Box className="sheetBackdrop" onClick={() => setIsOpen(false)} />}

      <Box className={`mobileSheet${isOpen ? ' mobileSheet--open' : ''}`}>
        <Box
          className="sheetHandle"
          id={`${id}__button_generateResource`}
          role="button"
          tabIndex={0}
          aria-expanded={isOpen}
          aria-label={isOpen ? 'Hide resource options' : 'Generate a Resource'}
          onClick={() => setIsOpen(!isOpen)}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setIsOpen(!isOpen)}
        >
          <Typography className="sheetHandleLabel">Generate a Resource</Typography>
          <FontAwesomeIcon
            icon={isOpen ? faChevronDown : faChevronUp}
            className="sheetHandleToggle"
          />
        </Box>

        {isOpen && (
          <Box className="sheetOptions">
            {RESOURCE_TYPES.map(({ id: typeId, label, route }) => (
              <Box
                key={typeId}
                className="sheetOption"
                id={`${id}__button_generate_${typeId}`}
                role="button"
                tabIndex={0}
                onClick={() => goTo(route)}
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && goTo(route)}
              >
                <Typography className="optionLabel">{label}</Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};
